import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AutocompleteInput } from '@dhl/inputs'
import { AddressInput } from '@dhl/input-address'
import { useCustomAddressFormat } from '~/hooks'
import { PaperSection } from '~/widgets'
import { topLevelDomain, arrayWithItemFirst } from '~/helpers'

type Props = {
  selectedCountryCode: string
  countryCodes: string[]
}

export const AddressDetails = ({ selectedCountryCode, countryCodes }: Props) => {
  const { t } = useTranslation()
  const sortedCountryCodes = arrayWithItemFirst(countryCodes)(topLevelDomain().toUpperCase())
  const countryCodeOptions = sortedCountryCodes
    .map((countryCode) => ({
      key: countryCode,
      label: t(`country.${countryCode}`),
    }))
    .sort((o1, o2) => (o1.label < o2.label ? -1 : 1))

  const countryCode =
    countryCodes.includes(selectedCountryCode) || countryCodeOptions.length === 0
      ? selectedCountryCode
      : countryCodeOptions[0].key
  const { customAddressFormat } = useCustomAddressFormat(countryCode)

  return (
    <PaperSection title={t('myAddress')}>
      <Grid container direction="column" spacing={2} size={{ xs: 12 }}>
        <Grid>
          <AutocompleteInput<{ key: string; label: string }, false>
            name="address.countryCode"
            label={t('components.addressInput.country')}
            options={countryCodeOptions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(left, right) => left.key === right.key}
            fullWidth
          />
        </Grid>
        {customAddressFormat && (
          <Grid>
            <AddressInput name="address" addressFormat={customAddressFormat} />
          </Grid>
        )}
      </Grid>
    </PaperSection>
  )
}
